import { sourceReferenceKey } from './externalSourceReferences';

// Adopting a live source column into an external table.
//
// The writes are computed from the table document as it is NOW (the caller reads it
// inside a Firestore transaction), never from the copy the settings page holds, so two
// Add actions in flight append to each other instead of the last write cloning stale
// arrays and undoing the first. The column is pinned in the same write: Validate Schema
// refreshes the pin only for columns the table already knows, so a column that is looked
// at but not adopted stays reported as new (M112).

export function assertExternalSchemaCurrent(tableDoc, connectionDoc, context) {
  const connectionRevision = context?.connection_revision;
  if (!context || !connectionRevision || !tableDoc || !connectionDoc
      || tableDoc.storage !== 'external' || tableDoc.status === 'Deleting'
      || tableDoc.createdAt !== context.table_created_at
      || tableDoc.connection_id !== context.connection_id
      || sourceReferenceKey(tableDoc.source?.table_ref) !== sourceReferenceKey(context.source?.table_ref)
      || connectionDoc.deleting || connectionDoc.creating
      || connectionDoc.operation_id !== connectionRevision.operation_id
      || connectionDoc.updated_at !== connectionRevision.updated_at) {
    throw new Error('The table or connection changed. Validate the schema again.');
  }
}

/**
 * Return the field updates that add `remoteColumn` to `tableDoc` under `name`, or null
 * when a column of that name or remote is already present.
 */
export const buildExternalColumnAddition = (tableDoc, remoteColumn, name, fallbackDisplayOrder) => {
  const detailColumns = tableDoc.detailColumns || [];
  const present = detailColumns.some(
    (column) => column.name === name || column.remote === remoteColumn.remote,
  );
  if (present) return null;

  const baseOrder = tableDoc.display_order || fallbackDisplayOrder;
  return {
    detailColumns: [
      ...detailColumns,
      { name, type: remoteColumn.proposed_type || 'Text', remote: remoteColumn.remote },
    ],
    display_columns: { ...(tableDoc.display_columns || {}), [name]: true },
    display_order: { ...baseOrder, detail: [...(baseOrder.detail || []), name] },
    pinned_schema: { ...(tableDoc.pinned_schema || {}), [remoteColumn.remote]: remoteColumn.native_type },
  };
};
